export function tuneMapInteractionSpeed(map, overrides = {}) {
  if (!map) return () => {}

  const defaults = {
    transitionDuration: 180,
    transitionDelay: 0,
    wheelZoomRate: 1 / 240,
    trackpadZoomRate: 1.5,
    touchZoomRate: 1.3,
    keyboardPanOffset: 120,
    keyboardZoomRate: 1.4,
    movingClassDebounce: 180,
  }

  const settings = { ...defaults, ...overrides }

  const applyInteractionTuning = () => {
    try {
      if (typeof map.setTransition === 'function') {
        map.setTransition({
          duration: settings.transitionDuration,
          delay: settings.transitionDelay,
        })
      }
    } catch (_) {}

    try {
      const scrollZoom = map.scrollZoom
      if (scrollZoom && typeof scrollZoom.setWheelZoomRate === 'function') {
        scrollZoom.setWheelZoomRate(settings.wheelZoomRate)
      }
      if (scrollZoom && typeof scrollZoom.setZoomRate === 'function') {
        scrollZoom.setZoomRate(settings.trackpadZoomRate)
      }
    } catch (_) {}

    try {
      const touch = map.touchZoomRotate
      if (touch && typeof touch.setTouchZoomRate === 'function') {
        touch.setTouchZoomRate(settings.touchZoomRate)
      }
    } catch (_) {}

    try {
      const keyboard = map.keyboard
      if (keyboard && typeof keyboard.setPanOffset === 'function') {
        keyboard.setPanOffset(settings.keyboardPanOffset)
      }
      if (keyboard && typeof keyboard.setZoomRate === 'function') {
        keyboard.setZoomRate(settings.keyboardZoomRate)
      }
    } catch (_) {}
  }

  const ensureApplied = () => {
    if (typeof map.isStyleLoaded === 'function' && map.isStyleLoaded()) {
      applyInteractionTuning()
    }
  }

  const onLoad = () => applyInteractionTuning()
  const onStyle = () => applyInteractionTuning()

  try {
    ensureApplied()
    map.on('load', onLoad)
    map.on('styledata', onStyle)
  } catch (_) {}

  const container = typeof map.getContainer === 'function' ? map.getContainer() : null
  let removeMovingClassTimeout = null

  if (container) {
    container.classList.add('oh-map-motion')

    const activate = () => {
      container.classList.add('oh-map-motion--active')
      if (removeMovingClassTimeout) {
        clearTimeout(removeMovingClassTimeout)
        removeMovingClassTimeout = null
      }
    }

    const deactivate = () => {
      if (removeMovingClassTimeout) clearTimeout(removeMovingClassTimeout)
      removeMovingClassTimeout = window.setTimeout(() => {
        container.classList.remove('oh-map-motion--active')
        removeMovingClassTimeout = null
      }, settings.movingClassDebounce)
    }

    try {
      map.on('movestart', activate)
      map.on('moveend', deactivate)
      map.on('idle', deactivate)
    } catch (_) {}

    return () => {
      if (removeMovingClassTimeout) {
        clearTimeout(removeMovingClassTimeout)
        removeMovingClassTimeout = null
      }
      try {
        map.off('load', onLoad)
        map.off('styledata', onStyle)
      } catch (_) {}
      try {
        map.off('movestart', activate)
        map.off('moveend', deactivate)
        map.off('idle', deactivate)
      } catch (_) {}
      container.classList.remove('oh-map-motion')
      container.classList.remove('oh-map-motion--active')
    }
  }

  return () => {
    try {
      map.off('load', onLoad)
      map.off('styledata', onStyle)
    } catch (_) {}
  }
}
